<template>
  <div class="logo">
    <a @click="toHome"><LogoSvg alt="logo" /><h1 v-if="showTitle">{{ title }}</h1></a>
  </div>
</template>

<script>
import LogoSvg from '@/assets/logo.svg?inline'

export default {
  name: 'Logo',
  components: {
    LogoSvg
  },
  props: {
    title: {
      type: String,
      default: '病理标注云平台',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  methods: {
    toHome () {
      this.$store.dispatch('ToHome', { pageName: 'home' })
    }
  }
}
</script>
